export default __webpack_public_path__ + "static/media/Montain.450ca51d.svg";